import React from 'react';
import { Box, HStack, Text } from '@chakra-ui/react';

interface LegendItem {
  color: string;
  label: string;
}

interface ColorLegendProps {
  items: LegendItem[];
}

export const ColorLegend: React.FC<ColorLegendProps> = ({ items }) => {
  return (
    <Box mb={4} p={3} bg="gray.50" borderRadius="md" border="1px solid" borderColor="gray.200">
      <HStack spacing={4} flexWrap="wrap">
        {items.map((item, index) => (
          <HStack key={index} spacing={2}>
            <Box
              w={4}
              h={4}
              bg={item.color}
              borderRadius="full"
              border="1px solid"
              borderColor="gray.300"
            />
            <Text fontSize="sm">{item.label}</Text>
          </HStack>
        ))}
      </HStack>
    </Box>
  );
};